import { loading, error } from 'State/actions';
import { getControlInfo } from 'State/controlInfo/actions';
import { getCaseTypes } from 'State/caseTypes/actions';
import * as types from './types';
import {
  DC_IMPORT_FETCHING,
  DC_IMPORT_FETCH_ERROR,
  DCIMPORT_FILECONFIG_SAVE_FILE,
  DC_IMPORT_SAVE_CONFIG_NAME,
  DC_IMPORT_SAVE_SELECTED_CONFIG_ID,
} from '../common/types';
import { DefaultConfigOptionEnum } from '../../helpers/Constants';
import { getConfigList } from '../hub/actions';
import { createToast, toastType } from 'Common/ToastHelper';

export const deleteConfig = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(DC_IMPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.postGenericDelete(
        `ImportConfiguration`,
        id
      );
      if (response.status === 200) {
        dispatch(saveSelectedConfigId(DefaultConfigOptionEnum.Blank));
        dispatch(getConfigList());
        createToast(
          toastType.success,
          'Success',
          'Configuration deleted successfully'
        );
        dispatch(setRedirectHome(true));
      }
    } catch (err) {
      createToast(toastType.error, 'Error', 'Failed to delete configuration.');
      if (err) {
        dispatch(error(DC_IMPORT_FETCH_ERROR, err));
      }
    }
    dispatch(loading(DC_IMPORT_FETCHING, false));
  };
};

export const saveConfig = (config) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(DC_IMPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `ImportConfiguration`,
        config
      );
      if (response.status === 200) {
        dispatch(saveSelectedConfigId(response.data.Data));
        dispatch(saveConfigName(config.Name));
        dispatch(getConfigList(true));
        createToast(
          toastType.success,
          'Success',
          'Configuration saved successfully.'
        );
      } else {
        createToast(toastType.error, 'Error', 'Save failed.');
      }
    } catch (err) {
      if (err) {
        err.response.data.Errors.forEach((error) =>
          createToast(toastType.error, 'Error', error.Message)
        );
        dispatch(error(DC_IMPORT_FETCH_ERROR, err));
      } else {
        createToast(toastType.error, 'Error', 'Save failed.');
      }
    }
    dispatch(loading(DC_IMPORT_FETCHING, false));
  };
};

export const fetchLookups = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(DC_IMPORT_FETCHING, true));

      await dispatch(getControlInfo(false));
      await dispatch(getCaseTypes());

      dispatch(loading(DC_IMPORT_FETCHING, false));
    } catch (ex) {
      dispatch(error(DC_IMPORT_FETCH_ERROR, ex));
    }
  };
};

export const getCaseTypeMappings = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(DC_IMPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric('ImportMapping/3/2');
      if (response.data && response.data.Data) {
        dispatch(setCaseTypeMapping(response.data.Data));
      } else {
        createToast(
          toastType.error,
          'Error',
          'Error retrieving Case Type mappings.'
        );
      }
    } catch (ex) {
      dispatch(error(DC_IMPORT_FETCH_ERROR, ex));
    }
    dispatch(loading(DC_IMPORT_FETCHING, false));
  };
};

export const saveCaseTypeMappings = (mappings) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(DC_IMPORT_FETCHING, true));
    try {
      const mappingData = mappings.map((mapping) => ({
        InternalField: mapping.value,
        ExternalField: mapping.key,
        MappingTypeId: 3,
        HeaderId: 2,
      }));
      const data = { MappingType: 3, Mappings: mappingData };
      dispatch(setCaseTypeMapping(mappingData));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'ImportMapping',
        data
      );

      if (response.status === 200) {
        createToast(
          toastType.success,
          'Success',
          'Case Type Mappings successfully updated.'
        );
      } else {
        createToast(
          toastType.error,
          'Error',
          'Failed to save Case Type Mappings.'
        );
      }
    } catch (ex) {
      createToast(
        toastType.error,
        'Error',
        'Failed to save Case Type Mappings.'
      );
      dispatch(error(DC_IMPORT_FETCH_ERROR, ex));
    }
    dispatch(loading(DC_IMPORT_FETCHING, false));
  };
};

export const setCaseTypeMapping = (data) => ({
  type: types.DC_SET_CASE_TYPE_MAPPING,
  payload: data,
});

export const clearImportFile = () => ({
  type: DCIMPORT_FILECONFIG_SAVE_FILE,
  payload: { file: { data: { Data: [] } }, name: '' },
});

export const saveConfigName = (name) => ({
  type: DC_IMPORT_SAVE_CONFIG_NAME,
  payload: name,
});

export const saveSelectedConfigId = (id) => ({
  type: DC_IMPORT_SAVE_SELECTED_CONFIG_ID,
  payload: id,
});

export const setRedirectHome = (value) => {
  return {
    type: types.DC_SET_REDIRECT_HOME,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/fileconfig/actions.js